import { preLoad } from "../include/module";
import { toggleMenu } from "../include/module";
import { anchorLink } from "../include/module";
import { footerSlider } from "../include/module";
import { togglePagetop } from "../include/module";
import { resizeHeader } from "../include/module";





(() => {

  preLoad();
  toggleMenu();
  anchorLink();
  // footerSlider();
  togglePagetop();
  resizeHeader();

})();



// WEBPACK FOOTER //
// ./src/assets/js/common/script.js